import { createAppAsyncThunk } from '@/domain/store.thunk';
import { downloadFileFromCode } from '@/domain/utils/download-a-file-from-code';

export const downloadTourImportCsvTemplate = createAppAsyncThunk(
  'projectTourOntour/downloadTourImportCsvTemplate',
  async () => {
    const url = '/fairly_score_import_tour_dates-template.csv';
    const filename = 'fairly_score_import_tour_dates-template.csv';
    downloadFileFromCode(url, filename);
  },
);
